import { alpha } from '@mui/material/styles';

import type {
  InterpolationConfig,
  OverWritable,
  Variant,
} from '../../@types/settings';
import type { ColorSchema } from '../palette';

const styleSelected = (color: ColorSchema): Variant => ({
  props: { color },
  style: ({ theme }: InterpolationConfig) => ({
    '&.Mui-selected': {
      borderColor: alpha(theme.palette[color].main, 0.48),
    },
  }),
});

export const toggleButton: OverWritable = {
  MuiToggleButton: {
    defaultProps: {
      color: 'primary',
    },

    variants: [
      styleSelected('primary'),
      styleSelected('secondary'),
      styleSelected('info'),
      styleSelected('success'),
      styleSelected('warning'),
      styleSelected('error'),
    ],

    styleOverrides: {
      root: ({ theme }) => ({
        color: theme.palette.text.primary,
        '& svg': { width: 24, height: 24 },
      }),
    },
  },

  MuiToggleButtonGroup: {
    defaultProps: {
      color: 'primary',
    },
    styleOverrides: {
      root: ({ theme }) => ({
        boxShadow: theme.customShadows.z8,
        border: `solid 1px ${theme.palette.grey[500_12]}`,
        '& .MuiToggleButton-root': {
          border: 'none',
          margin: 4,
          borderRadius: `${theme.shape.borderRadius}px !important`,
          '&.Mui-disabled': {
            border: 'none',
          },
        },
      }),
    },
  },
};
